export default __webpack_public_path__ + "resources/icons/d140-009f.png";